// extracted by mini-css-extract-plugin
export default {"login":"Login_login__x7f0g","title":"Login_title__NwVab"};